import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { cn } from "@/shared/lib/utils";

/**
 * Radix Tooltip wrapper.
 *
 * Surface tiers per design.md §6/§8/§10:
 *   content → glass-surface mid tier, rounded-xl, z-tooltip
 *   copy    → type-label-sm text-text
 */
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;
export const TooltipProvider = TooltipPrimitive.Provider;
export const TooltipPortal = TooltipPrimitive.Portal;

export const TooltipContent = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(function TooltipContent({ className, sideOffset = 6, ...props }, ref) {
  return (
    <TooltipPortal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          "z-tooltip rounded-xl glass-surface px-3 py-1.5",
          "type-label-sm text-text",
          className,
        )}
        {...props}
      />
    </TooltipPortal>
  );
});
